export default `float de(vec3 p){
    vec3 b = vec3(1.0,2.0,3.0); 
    float r = 0.1;      
    return length(max(abs(p)-b, 0.0))-r;
  }`